import React from 'react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';

const WalletConnectionModal = ({ isOpen, onClose, message = "You need to connect your wallet to make a purchase." }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black flex items-center justify-center z-[100] p-4"
      onClick={onClose}
    >
      <div 
        className="bg-[#111111] border border-white/30 rounded-xl max-w-md w-full p-8 shadow-xl shadow-white/20"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <div className="w-48 h-48 flex items-center justify-center">
            <img 
              src="/images/Chrome logo no background.png" 
              alt="Outsera" 
              className="w-full h-full object-contain"
              onError={(e) => {
                e.target.src = "/images/logo.png";
                e.target.onerror = () => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                };
              }}
            />
            {/* Fallback if no logo loads */}
            <div className="w-full h-full bg-gradient-to-br from-purple-600 to-blue-600 rounded-full flex items-center justify-center text-white font-bold text-4xl hidden">
              O
            </div>
          </div>
        </div>

        {/* Title */}
        <div className="text-center mb-6">
          <h3 className="text-2xl font-bold text-white mb-2 tracking-tight">
            Connect with Outsera
          </h3>
          <p className="text-gray-300 text-sm">
            Connect your wallet to continue
          </p>
        </div>

        {/* Message */}
        <div className="mb-6 text-center">
          <p className="text-gray-200 leading-relaxed text-sm">
            {message}
          </p>
        </div>

        {/* Connect wallet button */}
        <div className="flex justify-center mb-4">
          <WalletMultiButton className="!bg-white !text-black hover:!bg-gray-100 !rounded-xl !font-semibold !px-8 !py-3 !text-sm !border-0 !shadow-lg !transition-all !duration-300" />
        </div>

        {/* Instructional text */}
        <div className="text-center">
          <p className="text-gray-400 text-xs leading-relaxed">
            Connect your wallet to create pieces on Outsera
          </p>
        </div>
      </div>
    </div>
  );
};

export default WalletConnectionModal;
